import { SET_STEP_VALIDATION } from '../types';
 
export const updateStepValidationStatus = (name, isValid) => dispatch => {
    dispatch({
        type: SET_STEP_VALIDATION,
        name,
        isValid
    })
}




// WEBPACK FOOTER //
// ./src/actions/ValidationActions/clientValidation.js